import { FILTER_GAMES } from 'src/common/filter-games'

export default {
  state: () => ({
    freeSpins: [],
    freeBets: null,
    programsAvailable: [],
    activeStep: null,
    activeStepLoaded: false,
    conditionsChoices: null,
    bonusGameIdsList: null,
    freeSpinEnd: null,
    currentLiveCashBack: null,
  }),
  mutations: {
    UPDATE_PROGRAM_AVAILABLE(state, data) {
      state.programsAvailable = data
    },
    UPDATE_ACTIVE_STEP(state, data) {
      state.activeStep = data
      state.activeStepLoaded = true
    },
    UPDATE_ACTIVE_STEP_LOADED(state) {
      state.activeStepLoaded = true
    },
    UPDATE_USER_PROGRAM(state, payload) {
      if (state.programsAvailable.some((el) => +el.id === +payload.id)) {
        state.programsAvailable = state.programsAvailable.map((program) => {
          return +program.id === +payload.id ? payload : program
        })
      } else {
        state.programsAvailable = [...state.programsAvailable, payload]
      }
    },
    DELETE_USER_PROGRAM(state, { payload, getters }) {
      if (+getters.getActiveUserProgram?.id === +payload.userProgramId) {
        state.bonusGameIdsList = null
        state.activeStep = null
      }
      state.programsAvailable = state.programsAvailable.filter((el) => +el.id !== +payload.userProgramId)
    },
    UPDATE_PROGRAM(state, payload) {
      state.programsAvailable = state.programsAvailable.reduce((programsAvailable, userProgram) => {
        if (+userProgram.program.id === +payload.id) {
          programsAvailable.push({ ...userProgram, program: { ...userProgram.program, ...payload } })
          return programsAvailable
        }
        programsAvailable.push(userProgram)
        return programsAvailable
      }, [])
    },
    UPDATE_USER_STEP_BALANCE(state, value) {
      if (state.activeStep?.balance !== undefined && value?.user_step_id === state.activeStep?.id) {
        state.activeStep = { ...state.activeStep, balance: value.balance }
      }
    },
    UPDATE_CURRENT_LIVE_CASHBACK(state, data) {
      state.currentLiveCashBack = data
    },
    REMOVE_FREESPIN_BONUS_BY_ID(state, id) {
      state.freeSpins = state.freeSpins.filter((el) => el.id !== id)
    },
    UPDATE_PROMO_FREESPIN_AVAILABLE(state, freespinsArray) {
      const freeSpins = [...freespinsArray]

      if (freespinsArray.length === 0 && state.freeSpins.length !== 0) {
        state.freeSpinEnd = true
      }

      state.freeSpins = freeSpins.sort((a, b) => b.activated - a.activated)
    },
    UPDATE_FREE_BETS(state, freeBetsNumber) {
      state.freeBets = freeBetsNumber
    },
    UPDATE_CONDITIONS_CHOICES(state, choices) {
      state.conditionsChoices = choices
    },
    UPDATE_BONUS_GAME_IDS_LIST(state, bonusGameIdsList) {
      state.bonusGameIdsList = bonusGameIdsList
    },
    UPDATE_FREESPIN_END(state, value) {
      state.freeSpinEnd = value
    },
  },
  actions: {
    updateProgramAvailable({ commit }, payload) {
      commit('UPDATE_PROGRAM_AVAILABLE', payload)
    },
    updateFreeBets({ commit }, payload) {
      commit('UPDATE_FREE_BETS', payload)
    },
    updateActiveStep({ commit }, payload) {
      commit('UPDATE_ACTIVE_STEP', payload)
    },
    updateUserStepBalance({ commit }, payload) {
      commit('UPDATE_USER_STEP_BALANCE', payload)
    },
    updateCurrentLiveCashBack({ commit }, payload) {
      commit('UPDATE_CURRENT_LIVE_CASHBACK', payload)
    },
    removeFreespinByID({ commit }, payload) {
      commit('REMOVE_FREESPIN_BONUS_BY_ID', payload)
    },
    updatePromoFreespinAvailable({ commit }, payload) {
      commit('UPDATE_PROMO_FREESPIN_AVAILABLE', payload)
    },
    updateConditionsChoices({ commit }, payload) {
      commit('UPDATE_CONDITIONS_CHOICES', payload)
    },
    updateBonusGameIdsList({ commit }, payload) {
      commit('UPDATE_BONUS_GAME_IDS_LIST', payload)
    },
    updateProgram({ commit }, payload) {
      commit('UPDATE_PROGRAM', payload)
    },
    updateUserProgram({ commit }, payload) {
      commit('UPDATE_USER_PROGRAM', payload)
    },
    deleteUserProgram({ commit, getters }, payload) {
      commit('DELETE_USER_PROGRAM', { payload, getters })
    },
  },
  getters: {
    getActiveUserProgram: (s) => s.programsAvailable.find((el) => el.isActivated),
    getBonusGameIdsList: (s) => s.bonusGameIdsList ?? [],
    getProgramsAvailable: (s) => s.programsAvailable.filter((el) => !el.isActivated) || [],
    getConditionsChoices: (s) => s.conditionsChoices ?? [],
    getActiveStep: (s) => s.activeStep,
    getConditionStep: (s) => s.activeStep?.condition,
    getBonusType: (s) => {
      const filters = s.activeStep?.filters

      if (filters?.some((i) => i.type === FILTER_GAMES.ONLY_SPORT)) {
        return 'Sports'
      }

      return 'BonusGames'
    },
    getCurrentLiveCashBackLastPeriod: (s) => s.currentLiveCashBack?.lastPeriod ?? null,
    getCurrentLiveCashBackSum: (s) => {
      if (!s.currentLiveCashBack) {
        return null
      }

      const balance = s.currentLiveCashBack?.lastPeriod?.balance ?? 0

      if (balance <= 0) {
        return 0
      }

      const maxSum = s.currentLiveCashBack?.lastPeriod?.userSettings?.maxSum ?? 0
      return balance < maxSum ? balance : maxSum
    },
    countOfBonuses: (s, g) => {
      let count = g.getProgramsAvailable.length
      if (g.getActiveStep && g.getActiveStep?.condition !== 7) {
        count++
      }
      if (g.getFreeBets) {
        count++
      }
      if (g.freeSpins) {
        count = g.freeSpins.length + count
      }

      return count
    },
    freeSpins: (s) => s?.freeSpins ?? [],
    getFreeBets: (s) => s.freeBets,
    activeStepLoaded: (s) => s.activeStepLoaded,
    showBonusesGames: (s, g) => {
      if (!s.activeStep) {
        return false
      }

      const isCasinoSection = g.getActiveUserProgram?.program?.section === 0
      const isVagerByBonusBalance = s.activeStep?.condition === 6

      return isCasinoSection && isVagerByBonusBalance
    },
    hasFreespinsOnGame:
      (s, g) =>
      ({ manufacturer, game }) => {
        const activeFreespins = g.freeSpins.filter((bonus) => bonus.activated)
        if (!activeFreespins.length) {
          return false
        }

        return !!activeFreespins.find((bonus) => {
          return manufacturer === bonus.game.manufacturer.code && game === bonus.game.slug
        })
      },
  },
}
